export const CMI_LINK = 'https://childmind.org';
export const PRIVACY_LINK = 'https://mindlogger.org/privacy-policy';
export const TERMS_LINK = 'https://mindlogger.org/terms';
export const ABOUT_LINK = 'https://mindlogger.org';
export const CREDITS_LINK = 'https://www.gettingcurious.com/open-source-credits';
export const SUPPORT_LINK = 'https://help.mindlogger.org';
